
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91attendees_930JkhUPWGhI_qIxCDjCRtHoOA53pdJQ4Zfvn_45EgAxGEMMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/[cart]/addAttendees/[attendees].vue?macro=true";
import { default as confirmation4JrY7ScTIoJ8oroaqrTeu4bfYfBlfuras28U1hRVKbcMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/[cart]/confirmation.vue?macro=true";
import { default as indexrVYPdEYU83jFNFqZUagzzG9gMTyFKhCSc7y3GzchrOYMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/[cart]/index.vue?macro=true";
import { default as index_lXOIuR8fWyesrBB_VrRgje0s5tWkLDaZTPTzcXjvywMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/about/index.vue?macro=true";
import { default as privacy_45policyb3Ji4v_VhaN9Y2DkQlKYK64w0_0IHIPivu5hMMIIcJQMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/about/privacy-policy.vue?macro=true";
import { default as indexBh4aVZOFNfiI8KFoYwHflSyEjmQ4RBwv34KHZ1_45BOacMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/[type]/index.vue?macro=true";
import { default as indexidupJng_45IsBbbd85MNFwlTUGBMVX2OraWOMHSlFQgaoMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/admin/compliance/index.vue?macro=true";
import { default as _91user_93LxJVF5tPJLUHVQZx7N3dcr_45Ih3jp8qRWQQ8i9fL86CoMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/admin/compliance/user/[user].vue?macro=true";
import { default as indexrLfUfikpJYZnfe_5KzU0KWBszcVCCH25j8fQt_F_45x9YMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/admin/index.vue?macro=true";
import { default as _91courseId_93LieUevVJV2wsL8G3sE1lMmSlLZxoz8pjEGvXfAiH1Z0Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/ce-tracker/courses/add-course/[courseId].vue?macro=true";
import { default as indexC2KTd_qglyH7u6A33pZ2Jq2F5HQz0x0fTE2p_8t2EIYMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/ce-tracker/courses/add-course/index.vue?macro=true";
import { default as indexMY0aiqbtQZw0mF1Vj_45WD9gjug3uKk2bYZJiBy6cwBx4Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/ce-tracker/courses/index.vue?macro=true";
import { default as _91licenseId_93ohBvcRbo_qsaBGV2JpkvIGlm8bsslQ7wGWzyfvEggkEMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/ce-tracker/licenses/add-license/[licenseId].vue?macro=true";
import { default as indexxLX1RBRSglJ4xRrkOhO0pyYJWPMS01uSH2vMKXnKz5oMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/ce-tracker/licenses/add-license/index.vue?macro=true";
import { default as indexp56x_45vxDGDoz0CqJwKd3suOxeNQRAmkNRmVrxtkxbPAMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/ce-tracker/licenses/index.vue?macro=true";
import { default as index7XdaKcl7ty6s1cqRNH_45fkpPPGoSLkeaxgfVR0hp5_acMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/certification-series/index.vue?macro=true";
import { default as _91requestId_93EO4huweyloKjTG2oXjfVKnjA4rHYrSqcJkLpgCTSpbYMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/course-enrollment/[requestId].vue?macro=true";
import { default as indexTjJ2q6jMA5poh0jAYvwrPrAeSJVmva1ENuTy9lNBF3YMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/course-enrollment/index.vue?macro=true";
import { default as statuscpicZR0cNbGnjXbnX4rQVAJFayYiI2XvXK1f5Br4WKIMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/course-enrollment/status.vue?macro=true";
import { default as indexKejkaMyTNcWm2yWA_45E8kmqEEQpdKe68lpbq0JLEIxfMMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/index.vue?macro=true";
import { default as course_45detailsplouhnsjQKYnuN1EBAvywP7IoZ_45cSv_KAGTJYIM3yE8Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/instructor/course-details.vue?macro=true";
import { default as _91sessionId_93wMvaTjVII6n5IHA7FEfPYFns9zssQJWFos8EQT4rh2MMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/instructor/session-siso/[instructorId]/[sessionId].vue?macro=true";
import { default as attestZw_457zFeAEA1I0HgiDJQ8sTGg_45nYdGhX9WglhSjW34XcMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/order/[orderId]/attest.vue?macro=true";
import { default as certificateA32P_45GXCEJJLAZKSaBeRGt42uv5ZThP4_45R4CBLglzzIMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/order/[orderId]/certificate.vue?macro=true";
import { default as index2Zhz0yJGk8XT_45OEAfPrMgCyKuhuMDW2xmZjxKD3iwlwMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/order/[orderId]/index.vue?macro=true";
import { default as ashaw64maUcdBOD5BkeZ6oE2j7xYPhlJqx9WTlSiOgiDSDMMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/order/[orderId]/report/asha.vue?macro=true";
import { default as cebrokerTNwvePZMloB49PPCo6C764mcstZyNlzFf4SntxROWswMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/order/[orderId]/report/cebroker.vue?macro=true";
import { default as passwordG3gJvYJn6oc87KXf9teQ9x9k1HUQrz8wZolF7FPaMlEMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/password.vue?macro=true";
import { default as preferences3KX_BwOfqZnXSIC9joor3SkDokEkTdACCAZWnMQHsmEMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/preferences.vue?macro=true";
import { default as profile2_76wDz6tPFKn76X1qxstwpXJocqu2D7boqepIXfZ1QMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/profile.vue?macro=true";
import { default as subscriptionaELImRsJvGh1tbg9sxVh3UVjOfTJNxV3dBmzvxUHZfsMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/subscription.vue?macro=true";
import { default as accountAc7UPA_Tr0NHqzkZs4j_KWYXxwIpRlxN2Gg4rxEzmYAMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/account.vue?macro=true";
import { default as _91personId_93IB4oL1tL3hvkQpXxDnhS9Yr4OV_K_po09MvWLKsywNoMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/api/[yetiCode]/impersonate/[personId].vue?macro=true";
import { default as _91slug_93YSPPkB_5ImItnC0ZkM4aAakQA63JbaFcXSGtltL06_4Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/b/[brochureId]/[slug].vue?macro=true";
import { default as indexkY85RiDNjOqRolcAgwxbr1ntPPFJNk6K_459dNUTYux6MMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/b/[brochureId]/index.vue?macro=true";
import { default as ce_45acceleration_45virtual_45conference2C9TK5IB_45wSE5KrvGCv4c7fPgVexbvnj5SPQb4zKTLsMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/ce-acceleration-virtual-conference.vue?macro=true";
import { default as _91certSeries_936gcJCxizpR4vfzzHJnkeI_p5jITsfnOvtYK4Amvwcr0Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/[certSeries].vue?macro=true";
import { default as indexhiUDxY9SnsenGGUXVO99Hx4tDXRvvoK8lE6j_XO7jv4Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/index.vue?macro=true";
import { default as adolescent_45athletezMkc14qfcRA01lG2cgcbqrqpJ2MPzq_chp7nsHEZNEEMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/adolescent-athlete.vue?macro=true";
import { default as cancer_45rehabSAsSXcsdsL5_lkNvHrKNw2M9VGv0i1tRW4llZz_zCvoMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/cancer-rehab.vue?macro=true";
import { default as cardiovascular_45and_45pulmonaryHi_y5qApp31zSL4UhEbH4YKzCKx5HLc9d2brdJqtVaMMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/cardiovascular-and-pulmonary.vue?macro=true";
import { default as fall_45preventionP8g0q8ZR0g7dYO4CCh5RBXYs5VjUGq2azL4yJH86Yk0Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/fall-prevention.vue?macro=true";
import { default as geriatricVA_45Xh2uBxHxH9AW9W82uVlKjK_45_x9l5SvYlE2Psy8tUMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/geriatric.vue?macro=true";
import { default as hand_45therapy1dLfrJXeIk656CF6gK_LWTKfOfeIS_bGTs5WYl3AUzkMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/hand-therapy.vue?macro=true";
import { default as home_45health8go8L2nHf69mmuYWcw6txzJSyfga2dmK0bynf_45fJW00Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/home-health.vue?macro=true";
import { default as lymphedemaFI04gmDoMks2FsT6IDvZZzkSsd4GpOjtm9cwNEAaLf4Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/lymphedema.vue?macro=true";
import { default as sports_45performance_45and_45rehabueB6UWNFFvQs6hrOoPDMo2k_kg8nsyFSvISY2qkRztQMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/sports-performance-and-rehab.vue?macro=true";
import { default as strokeGtBBw0kgTFC61cXKsf5G0WLjNoxR3PvPzc9P4akvzDoMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/stroke.vue?macro=true";
import { default as vestibularhfdb9MIytgSk2HnU9dq9xEE_45VDWTBiaZJaoPs8UPy2EMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/vestibular.vue?macro=true";
import { default as womens_45healthA0GslkZD2WtSEegUp6kjqdtROYy_45s1YTdNohWkqdQ40Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/womens-health.vue?macro=true";
import { default as coming_45soon_4572db81loQmn0q1uTDRv5Z7RU_45s1g9gBtOC8eplv1_450Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/coming-soon.vue?macro=true";
import { default as _91slug_93tLN5YkyJExfOs9QneS7QJaMbbIkGZPO42CaDGwegHrQMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/course/[courseId]/[slug].vue?macro=true";
import { default as indexaYDuHGSGLUq3NUwQU_qfy41qezAPe9ZnkJeav97ZbpAMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/course/[courseId]/index.vue?macro=true";
import { default as _91promo_93FPMd_45F7EiEo8eaXUSgjsm0arBjtnbslXJ57FBNXwO1EMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/[promo].vue?macro=true";
import { default as _91category_93GGmSHYA6t3jLICgvyQxagEMXCikn2I9UiQ0QpBuEa5UMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/category/[category].vue?macro=true";
import { default as email_45signup_45thank_45youCjCY_1YG0eKUnpEsVFNbjAv9XzQhQyaHUgCx4iCLB9UMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/email-signup-thank-you.vue?macro=true";
import { default as _91format_93dnJkJLVl8YxOxiGNuuuwzj0QPmVHMU8xKLJNkb_128QMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/format/[format].vue?macro=true";
import { default as indexXivze98A8B5A_45zWSLxv7rZojpNWBjJth2nrk3AwZWCMMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/free-course-stu/index.vue?macro=true";
import { default as indexk3_45T3fLVcJI6G2Zaj4wczi6gYSm1MOBl_8aWlTFFBhsMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/free-course/index.vue?macro=true";
import { default as indexkEHDFK_45BoL1dovbLMJxH8pwEEFf1xBQRctnpk4DawcAMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/index.vue?macro=true";
import { default as new75UvaKGFSYXISF0W0n_45tLt4qnwGiJ_45RTN6XC4ARCGw8Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/new.vue?macro=true";
import { default as _91profession_93S3IyAYxbhY0P5eOlDPnAfTkWVZHOIFBZDQWyySdHKPoMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/profession/[profession].vue?macro=true";
import { default as _91discount_93saNUHfEk4Wc_45SWz2ywRRcxMlPfrzOTMBit_45utAM7XYMMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/promo/[discount].vue?macro=true";
import { default as _91setting_93ygowfoosveX7IRAl8yHJ10Fu0i2RuDUj1bScA5lTBEQMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/setting/[setting].vue?macro=true";
import { default as _91state_93Y32pCqCBkxluyoQj18Q5L_MVJrU6itMRjuBHWMei0K0Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/state/[state].vue?macro=true";
import { default as _91type_93pxKbhSvW_HHgUQ0wgj6HZ0_lNxO6cLKypn4cnyqwguQMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/subscription/[type].vue?macro=true";
import { default as coursesaguLoHR0JDwmlssiAS2P1FLVVA6UsGdmfZan4ilr9cIMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses.vue?macro=true";
import { default as email_45signupggU8TLr7WG0DNk9w0CXDM_45g1ZHOpJGVAj9fk_yqTYckMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/email-signup.vue?macro=true";
import { default as errorwhVTCVPbgETQdYo4OIdh4TXLrkve3kItbENUDQAolaQMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/error.vue?macro=true";
import { default as formatsuiNIX0x_45VKErX7tz9BbcSoS0a4_45dFBzT3_45EQszOWYmEMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/formats.vue?macro=true";
import { default as free_45coursedyBLeQstzgN3JiRk8kGuCTUSuWL8leb3iAR5ubV0wy8Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/free-course.vue?macro=true";
import { default as ce_45solutionsKbNOjsG3tR6KOjSBddM3iR_45vIuLIiRCs6hnnJD918KsMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/ce-solutions.vue?macro=true";
import { default as edfundfcFfUkWuInG5qMPsdGouVTAxI1iiX1r_h4uABHxyY6sMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/client/edfund.vue?macro=true";
import { default as ivyrehabXGQqOevqY7EGx46bgWEQGJEVLpEvfzh4dt335Tgsk04Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/client/ivyrehab.vue?macro=true";
import { default as physiotecGE8HSM2m4dNZpMUyJ9oOgRxZ_lpDbDcjY0B0XN9PIxEMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/client/physiotec.vue?macro=true";
import { default as synchronyb7u4Qall079sRhWSeS6qP5RpUuTwRE0fKKZHlFTibyoMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/client/synchrony.vue?macro=true";
import { default as _91sessionId_93_45ARfRVMRgA6DVEi6_45mEf6c8LXv_45rGyrY20pOWFvmmyoMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/client/wvbot/[sessionId].vue?macro=true";
import { default as compliance_45leadership_45trainingEZdc7GB9wrV1Tvmvh3PzqlTQ5UYxDypC3hDJgqMm_qQMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/compliance-leadership-training.vue?macro=true";
import { default as indexyaEQsYMfAZ5DCEiXPSVxjrhibQdV9e8sdDkbThX7d5kMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/enterprise/index.vue?macro=true";
import { default as hepb8gw02oRkEZeJ2mddv_45S1QRfSRJxn458zemuC696SOkMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/hep.vue?macro=true";
import { default as indexEJvAJ3wEwa7h8h0__451LVm2Pl_45EUtl2nFQQJq4u1FDkcMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/index.vue?macro=true";
import { default as live_45webinarsvkCKkiOr_BtYlsbcIDwFm6_45PTpaCglxcAq8WnB6MahkMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/live-webinars.vue?macro=true";
import { default as _91slug_932I4jfVgrGZ0AhjIueIu5iX_ILEJsdSBvcdZvOi1PKnoMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/old-rewards/[slug].vue?macro=true";
import { default as _91slug_9368M_45XyTtn_UHhQYXcxEMJwDnCpPNPaLwWDvNDauPIb8Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/rewards/[slug].vue?macro=true";
import { default as schoolsr0_4578z0fO9slHiXrNuE6JpH3nQ7vYHIQsVtXkutV0dAMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/schools.vue?macro=true";
import { default as _91setting_93A9yz4c3_459gcDfTpSkZrnSNcanJS8XajFyWck2aI29bUMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/setting/[setting].vue?macro=true";
import { default as indexHw9eVj1SjFqd_Ixd_45wx6hGFcnf6CCAMOJ6JYBrN8RLIMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/small-teams/index.vue?macro=true";
import { default as indexoLFh3XdgCYvtGJHk_Isng_dJB3ESl0dPGKuZiGzpfP8Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/index.vue?macro=true";
import { default as _instructortfnULZrRdQakz_4MzibD30Yo2AZFoKGiUn_45mkiKAwDsMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/instructor/_instructor.vue?macro=true";
import { default as _91instructor_93J_457A_45WLTtagMDMSDUTUKIekJD8xJgG5yiiwraaAJorgMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/instructor/[instructor].vue?macro=true";
import { default as directory8nnzv_zWyqyqp9piv8tOnE1ksfPPlANz5BXfeAsVl_45YMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/instructor/directory.vue?macro=true";
import { default as live_45ce_45course_45statesIqg4SwgKiCWbYD5KLK4OnyrQLRA3IWYaG2GXF4sic5QMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/live-ce-course-states.vue?macro=true";
import { default as live_45webinarsMQosY24dtSAx6Ea6SJ3hac9EPV9HCIjbnBVIe3CWnIcMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/live-webinars.vue?macro=true";
import { default as _91sessionId_93CtJDzQemhYtiaAYpJWE0phSFWjgU0_45a31i5cI5oiS28Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/live/in-person-waiver/[sessionId].vue?macro=true";
import { default as index2Vw90LGRVqfw5sNwgYZ0oPUSwntgvTDRi4zi9EboQpMMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/live/index.vue?macro=true";
import { default as _91sessionId_93NJ84ImJfX6mmGgRYUuUzxrtQtZXBHlYNSqzqaTPnj4MMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/live/live-registration/[sessionId].vue?macro=true";
import { default as termsQ5FgAqDHJ9ebHqaFbFKpUCMCN5GEr_A7JdJaWLmAr1QMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/live/terms.vue?macro=true";
import { default as forgot_45passworda8fn5TiHekI8shPQphKiE_srxeCHLISfg_45vXwYhQcUwMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/login/forgot-password.vue?macro=true";
import { default as forgot_45usernameMkaJnZTXHj55vPLj4Mr8xd8FlrJml_9qIUM5oDh194gMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/login/forgot-username.vue?macro=true";
import { default as index7yOgm_4iNjJKjIXcxDcnf2E4CbvfWXTKKBM8r5uR6zQMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/login/index.vue?macro=true";
import { default as reset_45passwordxX1r5f4crCoru7kdV6vKmNbgtQP0kaV02K_4580yRJGXEMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/login/reset-password.vue?macro=true";
import { default as indexchNvDpe5emwrm36AAo_45GX3DZyoUO_FYNnAE5Jj4IiKsMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/online-course/[orderId]/[previewId]/index.vue?macro=true";
import { default as indexI40COdbd9HQw0_452E_Yi_45Iv0DjmKLtM7ANr86ib4fsgoMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/online-course/[orderId]/index.vue?macro=true";
import { default as other_45professionals8ECOgGCQSFG3MLmRXX2eSxUsfo_451sTe5FSwKhQqEVMkMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/other-professionals.vue?macro=true";
import { default as physical_45therapistVMJcbd5nKQt5H7uMYbre5oLh4EwVUnJG8lixO2L_4W4Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/physical-therapist.vue?macro=true";
import { default as physiotecCW5ic6AkPDhtGnxlzAB9SRlg_QRMDtQAoM3FPBbnPsYMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/physiotec.vue?macro=true";
import { default as _91profession_93k9_iGcDftxOmECbykiCeGaoXvS3Cav9nRF6ySX1EdsUMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/profession-v2/[profession].vue?macro=true";
import { default as professionHa42NwfIzTlW9TYNSkDfu7yJlhCIpqC9PPmmoAuAD04Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/profession.vue?macro=true";
import { default as rejoin6Q_XmMZq6Q4hpIik2vydWaIhUKItvAhPDPqMXllS0T8Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/rejoin.vue?macro=true";
import { default as reviewsjd1pdB_8RybSK9kSjsPFudc6II54nW_qkXIywPW2tVoMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/reviews.vue?macro=true";
import { default as _91slug_93mqmOhh9kAaO4iKLvFi6cJmuMw3jZlxA6df5BABSlrZQMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/s/[slug].vue?macro=true";
import { default as nashville_45july_452025NCU7W4dzzJcayuG5Vy5C1pQJg_0doKI9UKdAr0psHNkMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/signature-series/_seriesName/nashville-july-2025.vue?macro=true";
import { default as nashville_45july_4520253pSTknR_0mRDlHMvSyQwbr2zCCaNTgyNHXkLv3r1GmMMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/signature-series/[seriesName]/nashville-july-2025.vue?macro=true";
import { default as _91method_93OkVYzmruKyPjPbVbXmXLh8BqG4xNoYDHCdh3LOpC2wcMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/siso/[instructorId]/[method].vue?macro=true";
import { default as _91method_937zeFZi069V7lMTdq7BRADtPuEErw82HccFnvZRG8zJ0Meta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/siso/[instructorId]/[orderId]/[method].vue?macro=true";
import { default as _91state_93gdjLYTegQldSeU1TFFO3fBkLNoSKnycG4UlIZqoExHIMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/state-and-profession/[profession]/[state].vue?macro=true";
import { default as stylesheet24c14IbNlycoED8iI0OsgXonuPvH4KHaaVVh_OqffSAMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/stylesheet.vue?macro=true";
import { default as all_45accesscNWCgu6WKnPKGrFDdVS5yOMOSUQHvLYWYHqXKDAP_45MEMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/all-access.vue?macro=true";
import { default as _91slug_93T8_45KJhfxIefWd9oswmio3qVMLLs7tQl9JRQtUMtXbaUMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/core100/[slug].vue?macro=true";
import { default as expirediiD4L9pGQITO_45YqgCvTRVwN4vpv1tuX51sTxbq8dArYMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/expired.vue?macro=true";
import { default as hep8ensA0LBfjgv8ndiC0u04iSNc_45kAMLG6Y5Tpj_6LrrcMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/hep.vue?macro=true";
import { default as indexjqh7tiB31eAKsrpn_5oPM0RVGMMWoifbhNrpL4nz4xAMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/index.vue?macro=true";
import { default as online_45accesslU07huOaXAgEtxSTzilQ_X8H7c_xSPYYpVPTTJHFFIwMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/online-access.vue?macro=true";
import { default as pricingt9a4rM_45zYFBen1i2PEYqLcT3AZUMLlgOV84A1QxDATcMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/pricing.vue?macro=true";
import { default as subscription_45v2_Dm5cJSCIYAZDW3ZhMIn86UzyrCeQZD3r81O5P_454uvEMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/subscription-v2.vue?macro=true";
import { default as tcf_45j_r_pJX75BRdeet3ULe81hyFF_45fXuA_45FZ5lLR5RKkMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/tc.vue?macro=true";
import { default as upgrade_45allaccessqajFZozXVnPZYBJEAHuAnwMvgM3yWq8bCRwQWg0rbqUMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/upgrade-allaccess.vue?macro=true";
import { default as upgradeiOoohGAQMQvpQckLHCkHZEptbwyqt6_F4Tkh5420TlcMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/upgrade.vue?macro=true";
import { default as supportUIrT9nMwMSvy5PtWVJ_oClNkP72BH8h71_45tF_45K6qXfQMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/support.vue?macro=true";
import { default as topicsFKOgYU7I_45Y_455NFAYo_45SAri_45j7rGlaXS2Fqfm8IClxncMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/topics.vue?macro=true";
import { default as upgradeUTDDyu9SkCojVFhYphZSXheqjo3Xw58IGyC_A4sKEqAMeta } from "/var/lib/jenkins/workspace/Website Frontend - Production/pages/upgrade.vue?macro=true";
export default [
  {
    name: "cart-addAttendees-attendees",
    path: "/:cart()/addAttendees/:attendees()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/[cart]/addAttendees/[attendees].vue")
  },
  {
    name: "cart-confirmation",
    path: "/:cart()/confirmation",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/[cart]/confirmation.vue")
  },
  {
    name: "cart",
    path: "/:cart()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/[cart]/index.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/about/index.vue")
  },
  {
    name: "about-privacy-policy",
    path: "/about/privacy-policy",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/about/privacy-policy.vue")
  },
  {
    name: accountAc7UPA_Tr0NHqzkZs4j_KWYXxwIpRlxN2Gg4rxEzmYAMeta?.name,
    path: "/account",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account.vue"),
    children: [
  {
    name: "account-type",
    path: ":type()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/[type]/index.vue")
  },
  {
    name: "account-admin-compliance",
    path: "admin/compliance",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/admin/compliance/index.vue")
  },
  {
    name: "account-admin-compliance-user-user",
    path: "admin/compliance/user/:user()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/admin/compliance/user/[user].vue")
  },
  {
    name: "account-admin",
    path: "admin",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/admin/index.vue")
  },
  {
    name: "account-ce-tracker-courses-add-course-courseId",
    path: "ce-tracker/courses/add-course/:courseId()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/ce-tracker/courses/add-course/[courseId].vue")
  },
  {
    name: "account-ce-tracker-courses-add-course",
    path: "ce-tracker/courses/add-course",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/ce-tracker/courses/add-course/index.vue")
  },
  {
    name: "account-ce-tracker-courses",
    path: "ce-tracker/courses",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/ce-tracker/courses/index.vue")
  },
  {
    name: "account-ce-tracker-licenses-add-license-licenseId",
    path: "ce-tracker/licenses/add-license/:licenseId()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/ce-tracker/licenses/add-license/[licenseId].vue")
  },
  {
    name: "account-ce-tracker-licenses-add-license",
    path: "ce-tracker/licenses/add-license",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/ce-tracker/licenses/add-license/index.vue")
  },
  {
    name: "account-ce-tracker-licenses",
    path: "ce-tracker/licenses",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/ce-tracker/licenses/index.vue")
  },
  {
    name: "account-certification-series",
    path: "certification-series",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/certification-series/index.vue")
  },
  {
    name: "account-course-enrollment-requestId",
    path: "course-enrollment/:requestId()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/course-enrollment/[requestId].vue")
  },
  {
    name: "account-course-enrollment",
    path: "course-enrollment",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/course-enrollment/index.vue")
  },
  {
    name: "account-course-enrollment-status",
    path: "course-enrollment/status",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/course-enrollment/status.vue")
  },
  {
    name: "account",
    path: "",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/index.vue")
  },
  {
    name: "account-instructor-course-details",
    path: "instructor/course-details",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/instructor/course-details.vue")
  },
  {
    name: "account-instructor-session-siso-instructorId-sessionId",
    path: "instructor/session-siso/:instructorId()/:sessionId()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/instructor/session-siso/[instructorId]/[sessionId].vue")
  },
  {
    name: "account-order-orderId-attest",
    path: "order/:orderId()/attest",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/order/[orderId]/attest.vue")
  },
  {
    name: "account-order-orderId-certificate",
    path: "order/:orderId()/certificate",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/order/[orderId]/certificate.vue")
  },
  {
    name: "account-order-orderId",
    path: "order/:orderId()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/order/[orderId]/index.vue")
  },
  {
    name: "account-order-orderId-report-asha",
    path: "order/:orderId()/report/asha",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/order/[orderId]/report/asha.vue")
  },
  {
    name: "account-order-orderId-report-cebroker",
    path: "order/:orderId()/report/cebroker",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/order/[orderId]/report/cebroker.vue")
  },
  {
    name: "account-password",
    path: "password",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/password.vue")
  },
  {
    name: "account-preferences",
    path: "preferences",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/preferences.vue")
  },
  {
    name: "account-profile",
    path: "profile",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/profile.vue")
  },
  {
    name: "account-subscription",
    path: "subscription",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/account/subscription.vue")
  }
]
  },
  {
    name: "api-yetiCode-impersonate-personId",
    path: "/api/:yetiCode()/impersonate/:personId()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/api/[yetiCode]/impersonate/[personId].vue")
  },
  {
    name: "b-brochureId-slug",
    path: "/b/:brochureId()/:slug()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/b/[brochureId]/[slug].vue")
  },
  {
    name: "b-brochureId",
    path: "/b/:brochureId()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/b/[brochureId]/index.vue")
  },
  {
    name: "ce-acceleration-virtual-conference",
    path: "/ce-acceleration-virtual-conference",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/ce-acceleration-virtual-conference.vue")
  },
  {
    name: "certification-series-certSeries",
    path: "/certification-series/:certSeries()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/[certSeries].vue")
  },
  {
    name: "certification-series",
    path: "/certification-series",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/index.vue")
  },
  {
    name: "certification-series-old-adolescent-athlete",
    path: "/certification-series/old/adolescent-athlete",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/adolescent-athlete.vue")
  },
  {
    name: "certification-series-old-cancer-rehab",
    path: "/certification-series/old/cancer-rehab",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/cancer-rehab.vue")
  },
  {
    name: "certification-series-old-cardiovascular-and-pulmonary",
    path: "/certification-series/old/cardiovascular-and-pulmonary",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/cardiovascular-and-pulmonary.vue")
  },
  {
    name: "certification-series-old-fall-prevention",
    path: "/certification-series/old/fall-prevention",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/fall-prevention.vue")
  },
  {
    name: "certification-series-old-geriatric",
    path: "/certification-series/old/geriatric",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/geriatric.vue")
  },
  {
    name: "certification-series-old-hand-therapy",
    path: "/certification-series/old/hand-therapy",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/hand-therapy.vue")
  },
  {
    name: "certification-series-old-home-health",
    path: "/certification-series/old/home-health",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/home-health.vue")
  },
  {
    name: "certification-series-old-lymphedema",
    path: "/certification-series/old/lymphedema",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/lymphedema.vue")
  },
  {
    name: "certification-series-old-sports-performance-and-rehab",
    path: "/certification-series/old/sports-performance-and-rehab",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/sports-performance-and-rehab.vue")
  },
  {
    name: "certification-series-old-stroke",
    path: "/certification-series/old/stroke",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/stroke.vue")
  },
  {
    name: "certification-series-old-vestibular",
    path: "/certification-series/old/vestibular",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/vestibular.vue")
  },
  {
    name: "certification-series-old-womens-health",
    path: "/certification-series/old/womens-health",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/certification-series/old/womens-health.vue")
  },
  {
    name: "coming-soon",
    path: "/coming-soon",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/coming-soon.vue")
  },
  {
    name: "course-courseId-slug",
    path: "/course/:courseId()/:slug()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/course/[courseId]/[slug].vue")
  },
  {
    name: "course-courseId",
    path: "/course/:courseId()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/course/[courseId]/index.vue")
  },
  {
    name: coursesaguLoHR0JDwmlssiAS2P1FLVVA6UsGdmfZan4ilr9cIMeta?.name,
    path: "/courses",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses.vue"),
    children: [
  {
    name: "courses-promo",
    path: ":promo()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/[promo].vue")
  },
  {
    name: "courses-category-category",
    path: "category/:category()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/category/[category].vue")
  },
  {
    name: "courses-email-signup-thank-you",
    path: "email-signup-thank-you",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/email-signup-thank-you.vue")
  },
  {
    name: "courses-format-format",
    path: "format/:format()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/format/[format].vue")
  },
  {
    name: "courses-free-course-stu",
    path: "free-course-stu",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/free-course-stu/index.vue")
  },
  {
    name: "courses-free-course",
    path: "free-course",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/free-course/index.vue")
  },
  {
    name: "courses",
    path: "",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/index.vue")
  },
  {
    name: "courses-new",
    path: "new",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/new.vue")
  },
  {
    name: "courses-profession-profession",
    path: "profession/:profession()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/profession/[profession].vue")
  },
  {
    name: "courses-promo-discount",
    path: "promo/:discount()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/promo/[discount].vue")
  },
  {
    name: "courses-setting-setting",
    path: "setting/:setting()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/setting/[setting].vue")
  },
  {
    name: "courses-state-state",
    path: "state/:state()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/state/[state].vue")
  },
  {
    name: "courses-subscription-type",
    path: "subscription/:type()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/courses/subscription/[type].vue")
  }
]
  },
  {
    name: "email-signup",
    path: "/email-signup",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/email-signup.vue")
  },
  {
    name: "error",
    path: "/error",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/error.vue")
  },
  {
    name: "formats",
    path: "/formats",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/formats.vue")
  },
  {
    name: "free-course",
    path: "/free-course",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/free-course.vue")
  },
  {
    name: "group-sales-ce-solutions",
    path: "/group-sales/ce-solutions",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/ce-solutions.vue")
  },
  {
    name: "group-sales-client-edfund",
    path: "/group-sales/client/edfund",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/client/edfund.vue")
  },
  {
    name: "group-sales-client-ivyrehab",
    path: "/group-sales/client/ivyrehab",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/client/ivyrehab.vue")
  },
  {
    name: "group-sales-client-physiotec",
    path: "/group-sales/client/physiotec",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/client/physiotec.vue")
  },
  {
    name: "group-sales-client-synchrony",
    path: "/group-sales/client/synchrony",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/client/synchrony.vue")
  },
  {
    name: "group-sales-client-wvbot-sessionId",
    path: "/group-sales/client/wvbot/:sessionId()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/client/wvbot/[sessionId].vue")
  },
  {
    name: "group-sales-compliance-leadership-training",
    path: "/group-sales/compliance-leadership-training",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/compliance-leadership-training.vue")
  },
  {
    name: "group-sales-enterprise",
    path: "/group-sales/enterprise",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/enterprise/index.vue")
  },
  {
    name: "group-sales-hep",
    path: "/group-sales/hep",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/hep.vue")
  },
  {
    name: "group-sales",
    path: "/group-sales",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/index.vue")
  },
  {
    name: "group-sales-live-webinars",
    path: "/group-sales/live-webinars",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/live-webinars.vue")
  },
  {
    name: "group-sales-old-rewards-slug",
    path: "/group-sales/old-rewards/:slug()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/old-rewards/[slug].vue")
  },
  {
    name: "group-sales-rewards-slug",
    path: "/group-sales/rewards/:slug()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/rewards/[slug].vue")
  },
  {
    name: "group-sales-schools",
    path: "/group-sales/schools",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/schools.vue")
  },
  {
    name: "group-sales-setting-setting",
    path: "/group-sales/setting/:setting()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/setting/[setting].vue")
  },
  {
    name: "group-sales-small-teams",
    path: "/group-sales/small-teams",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/group-sales/small-teams/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/index.vue")
  },
  {
    name: "instructor-_instructor",
    path: "/instructor/_instructor",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/instructor/_instructor.vue")
  },
  {
    name: "instructor-instructor",
    path: "/instructor/:instructor()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/instructor/[instructor].vue")
  },
  {
    name: "instructor-directory",
    path: "/instructor/directory",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/instructor/directory.vue")
  },
  {
    name: "live-ce-course-states",
    path: "/live-ce-course-states",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/live-ce-course-states.vue")
  },
  {
    name: "live-webinars",
    path: "/live-webinars",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/live-webinars.vue")
  },
  {
    name: "live-in-person-waiver-sessionId",
    path: "/live/in-person-waiver/:sessionId()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/live/in-person-waiver/[sessionId].vue")
  },
  {
    name: "live",
    path: "/live",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/live/index.vue")
  },
  {
    name: "live-live-registration-sessionId",
    path: "/live/live-registration/:sessionId()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/live/live-registration/[sessionId].vue")
  },
  {
    name: "live-terms",
    path: "/live/terms",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/live/terms.vue")
  },
  {
    name: "login-forgot-password",
    path: "/login/forgot-password",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/login/forgot-password.vue")
  },
  {
    name: "login-forgot-username",
    path: "/login/forgot-username",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/login/forgot-username.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/login/index.vue")
  },
  {
    name: "login-reset-password",
    path: "/login/reset-password",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/login/reset-password.vue")
  },
  {
    name: "online-course-orderId-previewId",
    path: "/online-course/:orderId()/:previewId()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/online-course/[orderId]/[previewId]/index.vue")
  },
  {
    name: "online-course-orderId",
    path: "/online-course/:orderId()",
    meta: indexI40COdbd9HQw0_452E_Yi_45Iv0DjmKLtM7ANr86ib4fsgoMeta || {},
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/online-course/[orderId]/index.vue")
  },
  {
    name: "other-professionals",
    path: "/other-professionals",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/other-professionals.vue")
  },
  {
    name: "physical-therapist",
    path: "/physical-therapist",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/physical-therapist.vue")
  },
  {
    name: "physiotec",
    path: "/physiotec",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/physiotec.vue")
  },
  {
    name: "profession-v2-profession",
    path: "/profession-v2/:profession()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/profession-v2/[profession].vue")
  },
  {
    name: "profession",
    path: "/profession",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/profession.vue")
  },
  {
    name: "rejoin",
    path: "/rejoin",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/rejoin.vue")
  },
  {
    name: "reviews",
    path: "/reviews",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/reviews.vue")
  },
  {
    name: "s-slug",
    path: "/s/:slug()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/s/[slug].vue")
  },
  {
    name: "signature-series-_seriesName-nashville-july-2025",
    path: "/signature-series/_seriesName/nashville-july-2025",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/signature-series/_seriesName/nashville-july-2025.vue")
  },
  {
    name: "signature-series-seriesName-nashville-july-2025",
    path: "/signature-series/:seriesName()/nashville-july-2025",
    meta: nashville_45july_4520253pSTknR_0mRDlHMvSyQwbr2zCCaNTgyNHXkLv3r1GmMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/signature-series/[seriesName]/nashville-july-2025.vue")
  },
  {
    name: "siso-instructorId-method",
    path: "/siso/:instructorId()/:method()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/siso/[instructorId]/[method].vue")
  },
  {
    name: "siso-instructorId-orderId-method",
    path: "/siso/:instructorId()/:orderId()/:method()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/siso/[instructorId]/[orderId]/[method].vue")
  },
  {
    name: "state-and-profession-profession-state",
    path: "/state-and-profession/:profession()/:state()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/state-and-profession/[profession]/[state].vue")
  },
  {
    name: "stylesheet",
    path: "/stylesheet",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/stylesheet.vue")
  },
  {
    name: "subscription-all-access",
    path: "/subscription/all-access",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/all-access.vue")
  },
  {
    name: "subscription-core100-slug",
    path: "/subscription/core100/:slug()",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/core100/[slug].vue")
  },
  {
    name: "subscription-expired",
    path: "/subscription/expired",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/expired.vue")
  },
  {
    name: "subscription-hep",
    path: "/subscription/hep",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/hep.vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/index.vue")
  },
  {
    name: "subscription-online-access",
    path: "/subscription/online-access",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/online-access.vue")
  },
  {
    name: "subscription-pricing",
    path: "/subscription/pricing",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/pricing.vue")
  },
  {
    name: "subscription-subscription-v2",
    path: "/subscription/subscription-v2",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/subscription-v2.vue")
  },
  {
    name: "subscription-tc",
    path: "/subscription/tc",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/tc.vue")
  },
  {
    name: "subscription-upgrade-allaccess",
    path: "/subscription/upgrade-allaccess",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/upgrade-allaccess.vue")
  },
  {
    name: "subscription-upgrade",
    path: "/subscription/upgrade",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/subscription/upgrade.vue")
  },
  {
    name: "support",
    path: "/support",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/support.vue")
  },
  {
    name: "topics",
    path: "/topics",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/topics.vue")
  },
  {
    name: "upgrade",
    path: "/upgrade",
    component: () => import("/var/lib/jenkins/workspace/Website Frontend - Production/pages/upgrade.vue")
  }
]